import { templateEditorPath } from '@/features/templates/lib/template-paths'
import type { IngestionUpload } from './types/ingestion-upload'

/** Where the ingestion screens live (spec D5). The menu (shared/nav-config) carries the same literal. */
export const INGESTION_PATHS = {
  page: '/reporting/ingestion',
  legacy: '/integrations/ingestion-activity',
} as const

/** The current upload lives in the URL, so a reload keeps showing it (P3-R2). */
export const BATCH_SEARCH_PARAM = 'batch'

/** The selected tab lives in the URL next to `?batch=`; "all" is the default and carries no parameter. */
export const TAB_SEARCH_PARAM = 'tab'

/** Where «Review» takes a file the AI worked on: its draft template in the editor; null when the AI never touched it. */
export function uploadReviewPath(upload: Pick<IngestionUpload, 'aiTemplateId'>): string | null {
  return upload.aiTemplateId !== null ? templateEditorPath(upload.aiTemplateId) : null
}

/** Router state the list hands to Review, so leaving it lands on the same tab and batch. */
export interface ReviewNavigationState {
  returnTo: string
}

/** Where Review goes back to: the list it was opened from, or the list's default view. */
export function reviewReturnPath(state: unknown): string {
  const returnTo = (state as Partial<ReviewNavigationState> | null)?.returnTo
  return typeof returnTo === 'string' && returnTo.startsWith(INGESTION_PATHS.page) ? returnTo : INGESTION_PATHS.page
}
